import { __decorate, __metadata, __param } from "tslib";
import { injectable, inject } from 'inversify';
import NeoTypes from '../AppServices/NeoTypes';
var SecurityService = /** @class */ (function () {
    function SecurityService(authentication, authorisation) {
        this.authentication = authentication;
        this.authorisation = authorisation;
    }
    Object.defineProperty(SecurityService.prototype, "isAuthenticated", {
        get: function () {
            return this.authentication.isAuthenticated;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SecurityService.prototype, "user", {
        get: function () {
            return this.authentication.user;
        },
        enumerable: false,
        configurable: true
    });
    SecurityService.prototype.hasRole = function (roleName) {
        return this.isAuthenticated && this.authorisation.hasRole(roleName);
    };
    SecurityService = __decorate([
        injectable(),
        __param(0, inject(NeoTypes.Security.AuthenticationService.symbol)),
        __param(1, inject(NeoTypes.Security.AuthorisationService.symbol)),
        __metadata("design:paramtypes", [Object, Object])
    ], SecurityService);
    return SecurityService;
}());
export { SecurityService };
